export const sentencesMapper = function(sentences) {
  let result = [];

  result = {
    ...result,
    ...sentences.reduce(
        (prev, sentence) => ({
          ...prev,
          [sentence.id]: sentenceMapper(sentence)
        }),
        {}
    )
  };

  return result;
};

export const sentenceMapper = sentence =>  ({
    id: sentence.id,
    sentence: sentence.sentence,
});
